export class SelectItem {
  public id: string;
  public text: string;
  public name: string;
  public email: string;
  public useYn: string;
  public role: string;
  public prmsYn: string;
  public flag: string;
  public children: Array<SelectItem>;
  public parent: SelectItem;

  public constructor(source: any) {
    if (typeof source === 'string') {
      this.id = this.text = source;
    }
    if (typeof source === 'object') {
      this.id = source.id || source.text;
      this.text = source.text;
      this.name = source.name;
      this.email = source.email;
      this.role = source.role;
      this.prmsYn = source.prmsYn;
      this.flag = source.flag;
      this.useYn = source.useYn === undefined ? '' : source.useYn;
      if (source.children && source.text) {
        this.children = source.children.map((c: any) => {
          let r: SelectItem = new SelectItem(c);
          r.parent = this;
          return r;
        });
        this.text = source.text;
        this.name = source.name;
        this.email = source.email;
        this.role = source.role;
      }
    }
  }

  public fillChildrenHash(optionsMap: Map<string, number>, startIndex: number): number {
    let i = startIndex;
    this.children.map((child: SelectItem) => {
      optionsMap.set(child.id, i++);
    });
    return i;
  }

  public hasChildren(): boolean {
    return this.children && this.children.length > 0;
  }

  public getSimilar(): SelectItem {
    let r: SelectItem = new SelectItem(false);
    r.id = this.id;
    r.text = this.text;
    r.parent = this.parent;
    return r;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/form/select/ng-select/select-item.ts